import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SxProps, Theme } from "@mui/material/styles";

export const STextField = styled(TextField)(({ theme }) => ({
  width: "100%",

  "& label": {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
    fontWeight: 400,
    fontSize: "1.4rem",
    borderRadius: "1rem",
  },

  "& .MuiInputLabel-shrink": {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontWeight: 700,
    fontSize: "1.4rem",
    paddingRight: 6,
  },

  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: theme.shape.borderRadius,
  },

  "& .MuiInputBase-input": {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
    fontSize: "1.4rem",
  },
}));

export const containerSx: SxProps<Theme> = {
  borderRadius: 1,
  backgroundColor: "background.paper",
  p: { xs: "1.5rem", sm: "8px 32px 32px 8px" },
  m: { xs: "0.5rem", sm: "24px 0px 0px 48px" },
  width: { xs: "100%", sm: "95%" },
};

export const headerTitleSx: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: { xs: "1.6rem", sm: "2rem" },
  color: "text.primary",
};

export const profileFieldWrapperSx: SxProps<Theme> = {
  mt: { xs: 1.5, sm: 2 },
};

export const inputLabelSx: SxProps<Theme> = {
  position: "absolute",
  color: "text.primary",
  fontFamily: "inherit",
  fontSize: "1.4rem",
  backgroundColor: "background.paper",
  pl: "0.2rem",
  pr: "0.8rem",
};

export const profileSelectSx: SxProps<Theme> = {
  borderRadius: 1,
};

export const carrierBoxSx: SxProps<Theme> = {
  border: "1px dashed",
  borderColor: "grey.400",
  borderRadius: 1,
};

export const carrierSearchButtonWrapperSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "end",
  pt: 2,
};

export const cnpjSectionSx: SxProps<Theme> = {
  mt: { xs: 1, sm: 2 },
};

export const addButtonWrapperSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "end",
  pt: 0,
};

export const footerActionsSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 2,
};

export const submitButtonSx: SxProps<Theme> = {
  boxShadow: "none",
};

export const checklistIconStyle: React.CSSProperties = {
  height: "2rem",
};

export const spacerBoxSx: SxProps<Theme> = {
  height: "3rem",
};

export const getProfileLabelSx = (isTouched: boolean): SxProps<Theme> => ({
  ...inputLabelSx,
  fontWeight: isTouched ? 700 : 400,
});

export const getBtnTextSx = (disabled: boolean): SxProps<Theme> => ({
  fontWeight: "bold",
  textTransform: "none",
  fontSize: "1.4rem",
  color: disabled ? "text.disabled" : "primary.main",
});
